export const PAGE_SECTIONS = {
  SUBHEADER: 'pageSectionSubHeader',
  ARTICLE_PAGE: 'articlePage',
};
